import React, { useEffect, useState } from "react";
import { getResponsiveImage } from "../../utils/imageHelper";
import { Skeleton } from "@mui/material";
import { Helmet } from "react-helmet-async";

/* eslint-disable */

interface BannerComponentProps {
  multicotizadorData?: any;
  customImage?: string;
  children?: React.ReactNode;
}

declare const window: any;

const BannerComponent: React.FC<BannerComponentProps> = ({ multicotizadorData, customImage, children }) => {
  const [isPortrait, setIsPortrait] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>("");

  const desktopUrl = multicotizadorData?.[0]?.banner?.url ? getResponsiveImage(multicotizadorData[0].banner.url).desktop : '';
  const mobileUrl = multicotizadorData?.[0]?.banner_portrait?.url ? getResponsiveImage(multicotizadorData[0].banner_portrait.url).mobile : '';

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");

    const updateOrientation = () => {
      setIsPortrait(mediaQuery.matches);
    };

    updateOrientation();
    mediaQuery.addEventListener("change", updateOrientation);

    return () => {
      mediaQuery.removeEventListener("change", updateOrientation);
    };
  }, []);

  useEffect(() => {
    let url = "";
    if (customImage) {
      url = customImage;
    } else if (multicotizadorData && multicotizadorData.length > 0) {
      const path = isPortrait ? multicotizadorData[0]?.banner_portrait?.url : multicotizadorData[0]?.banner?.url;
      url = getResponsiveImage(path || '').desktop;
    }


    if (url) {
      setImageUrl(url);
      setImageLoaded(false);

      const img = new Image();
      img.onload = () => setImageLoaded(true);
      img.src = url;
    }
  }, [customImage, multicotizadorData, isPortrait]);

  return (
    <>
      <Helmet>
        {customImage && <link rel="preload" as="image" href={customImage} fetchPriority="high" />}
        {!customImage && mobileUrl && <link rel="preload" as="image" href={mobileUrl} media="(max-width: 768px)" fetchPriority="high" />}
        {!customImage && desktopUrl && <link rel="preload" as="image" href={desktopUrl} media="(min-width: 769px)" fetchPriority="high" />}
      </Helmet>
      <div
        className={`banner-multi-cotizacion-component`}
        style={{
          backgroundImage: imageLoaded ? `url(${imageUrl})` : "none",
          position: "relative"
        }}
      >
        {!imageLoaded && imageUrl && (
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            height="100%" 
            sx={{ position: "absolute", top: 0, left: 0, zIndex: 0 }} 
          />
        )}
        <div style={{ position: "relative", zIndex: 1, height: "100%" }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default BannerComponent;
